import React from 'react';
import Icon from "./Icon";

const IconWifi = ({tooltip}) => {
    return (
        <Icon image="/img/icons/icon-wifi.svg" tooltip={tooltip}/>
    )
};

export default IconWifi;